"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INFO_WINDOW_DISPLAY_MAX_POINTS = exports.CITY_LABEL = exports.STREET_LABEL = exports.NUMBER_LABEL = exports.TYPE_LABEL = exports.TIME_LABEL = exports.mapInitialState = exports.AMSTERDAM_COORDS = exports.DEFAULT_COUNTRY = exports.COLORS = void 0;
exports.COLORS = {
    white: '#fff',
    blue: '#2677FF',
    orange: '#d87303',
    green: '#16BE42',
    pathColor: '#1f5b29',
    notConnectedPathColor: '#6f7474',
    darkGreen: 'rgba(114, 164, 32, 1)',
    arrowColor: 'white',
};
exports.DEFAULT_COUNTRY = 'Netherlands';
exports.AMSTERDAM_COORDS = { lat: 52.3545653, lng: 4.7585401 };
exports.mapInitialState = {
    // Just default, required some default data but will be soon overriden.
    center: exports.AMSTERDAM_COORDS,
    zoom: 8,
};
exports.TIME_LABEL = 'Tijd:';
exports.TYPE_LABEL = 'Soort:';
exports.NUMBER_LABEL = 'Nummer:';
exports.STREET_LABEL = 'Straatnaam:';
exports.CITY_LABEL = 'Plaatsnaam:';
exports.INFO_WINDOW_DISPLAY_MAX_POINTS = 5;
